import { MenuLateral } from '@/components/shared/MenuLateral';
import { ComposicaoCPESQ } from '@/pages/Pesquisa/ComposicaoCPESQ';
import { PesquisadorColaborador } from '@/pages/Pesquisa/PesquisadorColaborador';
import { PesquisadorVisitanteConvidado } from '@/pages/Pesquisa/PesquisadorVisitanteConvidado';
import { PosDoutorado } from '@/pages/Pesquisa/PosDoutorado';
import { ProfessorColaborador } from '@/pages/Pesquisa/ProfessorColaborador';

import { Route, Routes } from 'react-router-dom';


const PesquisaRoutes = () => {
    return (
        <div className='flex'>

            <MenuLateral
                title='Pesquisa'
                menuType='menu-feagri-pesquisa'
            />

            <div className='pl-10'>
                <Routes>
                    <Route path='/colaboradores/pos-doutorado' element={<PosDoutorado />} />
                    <Route path='/colaboradores/pesquisador-visitante-convidado' element={<PesquisadorVisitanteConvidado />} />
                    <Route path='/colaboradores/pesquisador-colaborador' element={<PesquisadorColaborador />} />
                    <Route path='/colaboradores/professor-colaborador' element={<ProfessorColaborador />} />
                    <Route path='/comissao/composicao-cpesq' element={<ComposicaoCPESQ />} />

                </Routes>
            </div>
        </div>
    );
}

export { PesquisaRoutes };